import { IPropsInputField } from "./fieldPropertiesInterface";
import InputField from "./inputField";

function EmailField({
  model,
  attr,
  value,
  label,
  onChange,
  disabled,
  required,
  autoFocus,
  isError
}: IPropsInputField) {
  return (
    <InputField
      type='email'
      attr={attr}
      value={value}
      label={label}
      model={model}
      onChange={onChange}
      disabled={disabled}
      required={required}
      autoFocus={autoFocus}
      isError={isError}
    ></InputField>
  );
}

export default EmailField;